import { CellRange, DataMap } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import * as wjcCore from '@grapecity/wijmo';
import { CellType } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import { useMaster } from 'context/MasterContext';
import { useRestApi } from 'context/RestApiContext';
import { MessageModal } from 'components/modal/MessageModal';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import KoujiDaichoModal from 'views/KoujiDaicho/KoujiDaichoModal';
import SelectComponent from 'components/Input/SelectComponent';
import ClientCardEditModal from 'views/ClientCards/ClientCardEditModal';
import KoujiRiekiModal from 'views/KoujiDaicho/KoujiRiekiModal';
import ContactEmergencyOutlinedIcon from '@mui/icons-material/ContactEmergencyOutlined';
import { KoujiTagComponent } from 'components/Input/KoujiTagComponent';
import { KoujiTagSelectComponent } from 'components/Input/KoujiTagSelectComponent';
import { toFloat } from 'utils/numberUtils';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import * as wjGridXlsx from '@grapecity/wijmo.grid.xlsx';
import DownloadIcon from '@mui/icons-material/Download';

const KoujiDaichoList = (props) => {
  const restApi = useRestApi();

  // マスタ情報
  const master = useMaster();
  // グリッド
  const flexGrid = useRef();

  // スクロール位置
  const scrollPosition = useRef(0);

  // 売り上げ額合計
  const [totalSeisan, setTotalSeisan] = useState(0);

  // 原価金額合計
  const [totalGenka, setTotalGenka] = useState(0);

  // 粗利率の平均
  const [arariritsu, setArariritsu] = useState(0);

  // 営業利益額
  const [totalRieki, setTotalRieki] = useState(0);

  // 営業利益率
  const [riekiRitsu, setRiekiRitsu] = useState(0);

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 顧客一覧情報
  const [clients, setClients] = useState([]);

  // 工事台帳モーダルパラメタ
  const [koujiDaichoModalParam, setKoujiDaichoModalParam] = useState({});

  // カード編集モーダルパラメタ
  const [cardEditModalParam, setCardEditModalParam] = useState({});

  // 利益管理モーダルパラメタ
  const [riekiManageModalParam, setRiekiManageModalParam] = useState({});

  // 選択中の顧客ID
  const [targetClientCd, setTargetClientCd] = useState();

  // 顧客検索条件
  const [searchCondition, setSearchCondition] = useState({
    YEAR: '',
    MONTH: '',
    YEAR_END: '',
    MONTH_END: '',
  });

  // 工事内容タグ
  const [koujiTags, setKoujiTags] = useState([]);
  // 工事タグの追加
  const addKoujiTag = (tagCodes) => {
    setKoujiTags([...koujiTags, ...tagCodes.filter((x) => !koujiTags.some((k) => k == x))]);
  };
  // 工事タグの削除
  const deleteKoujiTag = (tagCode) => {
    let _koujiTags = koujiTags.filter((x) => x != tagCode);

    // 工事タグが2件未満になった場合はいずれかに該当のチェックはOFFにする
    if (_koujiTags.length < 2) {
      setSearchCondition({ ...searchCondition, ANY_KOUJI_TAGS: false });
    }
    setKoujiTags(_koujiTags);
  };
  // いずれかに該当チェックボックスの変更処理
  const handleChangeAnyKoujiTags = (e) => {
    const isChecked = e.target.checked;
    let _searchCondition = { ...searchCondition, ANY_KOUJI_TAGS: isChecked };
    setSearchCondition(_searchCondition);
  };

  // 検索時に再選択
  useEffect(() => {
    if (targetClientCd) {
      const index = clients.indexOf(clients.find((c) => c['CLIENT_CD'] == targetClientCd));
      if (index >= 0) {
        setTimeout(() => {
          flexGrid.current.control.select(new CellRange(index), true);
          setTimeout(() => {
            flexGrid.current.control.scrollPosition = scrollPosition.current;
          }, 50);
        }, 200);
      }
    }
    // 合計金額を計算
    setTotalSeisan(clients.reduce((a, x) => a + toFloat(x['SEIKSAN_KIN']), 0));

    //　粗利率を計算、原価=0円は対象外
    let arariTagets = clients.filter((x) => x.CYU_KIN_TOTAL != 0);
    let _totalSeisan = arariTagets.reduce((a, x) => a + toFloat(x['SEIKSAN_KIN']), 0);
    let _totalArari = arariTagets.reduce((a, x) => a + toFloat(x['ARARI']), 0);

    // 粗利率を計算
    let arariritu = _totalSeisan ? _totalArari / _totalSeisan : 0;
    arariritu = !isNaN(arariritu) ? arariritu : 0;
    arariritu = wjcCore.Globalize.format(arariritu, 'p1');
    setArariritsu(arariritu);

    // 原価合計を計算
    let _totalGenka = arariTagets.reduce((a, x) => a + toFloat(x['CYU_KIN_TOTAL']), 0);
    setTotalGenka(_totalGenka);
  }, [clients]);

  // 初期表示処理
  useEffect(() => {
    searchClients();
  }, [searchCondition, koujiTags]);

  // 編集処理
  const handleChange = (prop) => (target) => {
    const val = target?.value ?? target?.target.value;
    let _searchCondition = { ...searchCondition, [prop]: val };

    if (prop == 'YEAR' && !val) {
      _searchCondition = { ..._searchCondition, MONTH: '', MONTH_END: '' };
    } else if (prop == 'MONTH' && !val) {
      _searchCondition = { ..._searchCondition, MONTH_END: '' };
    }
    setSearchCondition(_searchCondition);
  };

  //　粗利率を取得
  const getArarititu = (seikyu, order) => {
    // 粗利
    let arari = seikyu - order;
    // 粗利率
    let arariritu = arari / seikyu;
    arariritu = !isNaN(arariritu) ? arariritu : 0;
    return arariritu;
  };

  // 検索処理
  const searchClients = (clientCd = null) => {
    setTargetClientCd(clientCd);
    restApi.post(
      '/api/order/list',
      { condition: searchCondition, koujiTags: koujiTags },
      (data) => {
        setClients(
          data.clients.map((x) => ({
            ...x,
            ADDRESS: `${x.BUILD_CITY}`,
            ARARI: x.SEIKSAN_KIN - x.CYU_KIN_TOTAL,
            ARARI_RITU: getArarititu(x.SEIKSAN_KIN, x.CYU_KIN_TOTAL),
          }))
        );
        // 営業利益額
        const rieki = data.total.SEIKSAN_KIN - data.total.CYU_KIN_TOTAL - data.total.KEIHI;
        setTotalRieki(rieki);

        // 利益率を算出
        const riekiRitu = rieki / data.total.SEIKSAN_KIN;
        setRiekiRitsu(!isNaN(riekiRitu) ? wjcCore.Globalize.format(riekiRitu, 'p1') : 0);
      }
    );
  };

  // 編集ボタン
  const handleOnClickEditClient = useCallback(() => {
    // スクロール位置を保持
    scrollPosition.current = flexGrid.current.control.scrollPosition;

    setKoujiDaichoModalParam({
      show: true,
      clientCd: flexGrid.current.control.selectedItems[0].CLIENT_CD,
    });
  }, []);

  // カード編集ボタン
  const handleOnClickEditCard = useCallback(() => {
    // スクロール位置を保持
    scrollPosition.current = flexGrid.current.control.scrollPosition;

    setCardEditModalParam({
      show: true,
      card: flexGrid.current.control.selectedItems[0],
    });
  }, []);

  // 一覧の更新時に件数を更新する
  const [count, setCount] = useState(0);
  useEffect(() => {
    setCount(clients.length);
  }, [clients]);

  // フィルタの変更処理
  const filterApplied = (s, e) => {
    let grid = s.grid;
    setCount(grid?.collectionView?.items.length);
  };

  // 利益管理ボタンのクリック処理
  const handleOnClickRiekiManage = useCallback(() => {
    setRiekiManageModalParam({
      show: true,
      searchCondition: searchCondition,
    });
  }, [searchCondition]);

  // Excelダウンロード
  const handleExcelDownload = () => {
    const grid = flexGrid.current.control; // FlexGridコンポーネントへの参照を取得
    const fileName = '工事台帳一覧.xlsx'; // ダウンロードするExcelファイルの名前

    // グリッドをExcel形式のオブジェクトに変換
    let workbook = wjGridXlsx.FlexGridXlsxConverter.save(grid, {
      includeCellStyles: true,
      includeColumns: function (column) {
        return column.binding; // 値なしは含めない（ボタンの項目）
      },
    });

    // 行の高さを固定（例えば20に統一）
    workbook.sheets.forEach((sheet) => {
      sheet.rows.forEach((row) => {
        row.height = 20; // 単位は Excel の標準行高さ単位
      });
    });

    // 保存
    workbook.save(fileName);
  };

  return (
    <>
      <Card className="m-0 pl-3 pt-1  table-container">
        <Row style={{ display: 'flex' }}>
          <div className="ml-3 pr-1">
            <label>年</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SelectComponent value={searchCondition.YEAR} onChange={handleChange('YEAR')}>
                <option key={0} value={''}>
                  {'　'}
                </option>

                {Array.from({ length: new Date().getFullYear() - 2018 + 1 }, (_, i) => 2018 + i)
                  .reverse()
                  .map((i) => (
                    <option key={i} value={i}>
                      {i}年
                    </option>
                  ))}
              </SelectComponent>
            </div>
          </div>
          {searchCondition.YEAR && (
            <>
              <div className="ml-1 pr-1">
                <label>　</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <SelectComponent value={searchCondition.MONTH} onChange={handleChange('MONTH')}>
                    <option key={0} value={''}>
                      {'　'}
                    </option>

                    {Array.from({ length: 12 }, (_, i) => i + 1).map((i) => (
                      <option key={i} value={i}>
                        {i}月
                      </option>
                    ))}
                  </SelectComponent>
                </div>
              </div>
              <div className="ml-1 pr-1">
                <label className="ml-3">　</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  ～
                  <SelectComponent
                    value={searchCondition.YEAR_END}
                    onChange={handleChange('YEAR_END')}
                  >
                    <option key={0} value={''}>
                      {'　'}
                    </option>

                    {Array.from({ length: new Date().getFullYear() - 2018 + 1 }, (_, i) => 2018 + i)
                      .reverse()
                      .map((i) => (
                        <option key={i} value={i}>
                          {i}年
                        </option>
                      ))}
                  </SelectComponent>
                </div>
              </div>
              {searchCondition.YEAR_END && (
                <div className="ml-1 pr-1">
                  <label>　</label>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectComponent
                      className="ml-0"
                      value={searchCondition.MONTH_END}
                      onChange={handleChange('MONTH_END')}
                    >
                      <option key={0} value={''}>
                        {'　'}
                      </option>

                      {Array.from({ length: 12 }, (_, i) => i + 1).map((i) => (
                        <option key={i} value={i}>
                          {i}月
                        </option>
                      ))}
                    </SelectComponent>
                  </div>
                </div>
              )}
            </>
          )}
          <div className="ml-3 pr-1">
            <label>売り上げ額合計</label>
            <div className="mt-2 text-right" style={{ fontSize: '15pt', width: 160 }}>
              {totalSeisan.toLocaleString()}円
            </div>
          </div>
          <div className="ml-3 pr-1">
            <label>工事原価合計</label>
            <div className="mt-2 text-right" style={{ fontSize: '15pt', width: 160 }}>
              {totalGenka.toLocaleString()}円
            </div>
          </div>
          <div className="ml-3 pr-1">
            <label>粗利益率</label>
            <div className="mt-2 text-right" style={{ fontSize: '15pt', width: 100 }}>
              {arariritsu}
            </div>
          </div>
          <div className="ml-3 pr-1">
            <label>営業利益額</label>
            <div className="mt-2 text-right" style={{ fontSize: '15pt', width: 160 }}>
              {totalRieki.toLocaleString()}円
            </div>
          </div>
          <div className="ml-3 pr-1">
            <label>営業利益率</label>
            <div className="mt-2 text-right" style={{ fontSize: '15pt', width: 100 }}>
              {riekiRitsu}
            </div>
          </div>

          <div className="ml-3 pr-1">
            <label>　</label>
            <div>
              <Button
                style={{ width: '93px', height: '32px' }}
                variant="primary"
                className="btn-fill m-0 p-0"
                size="sm"
                onClick={() => {
                  handleOnClickRiekiManage();
                }}
              >
                <AssessmentOutlinedIcon className="mr-1" style={{ fontSize: 18 }} />
                利益管理
              </Button>
            </div>
          </div>
          <Col md="12">
            <label>タグ</label>
            <div style={{ display: 'flex' }}>
              <KoujiTagSelectComponent
                labels={master.label}
                tagTypes={master.tagTypes}
                callAddTag={addKoujiTag}
              />
              {/** 2件以上の場合にいずれかに該当を選択可能 */}
              {koujiTags.length >= 2 && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <label
                    className="mt-1 ml-3"
                    style={{ fontSize: '14pt', color: 'black', whiteSpace: 'nowrap' }}
                  >
                    <input
                      className="mr-3"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={searchCondition.ANY_KOUJI_TAGS}
                      onChange={handleChangeAnyKoujiTags}
                    ></input>
                    いずれかに該当
                  </label>
                </div>
              )}
              <div className="ml-2 mt-1">
                {koujiTags.map((x) => (
                  <KoujiTagComponent labels={master.label} tagCode={x} onDelete={deleteKoujiTag} />
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <div className="mt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            件数：{count}件
            {!searchCondition.YEAR && <span style={{ color: 'blue' }}>　※3年分を表示</span>}
          </div>
          <Button
            variant="success"
            className="btn-fill p-0 pl-1 pr-1 mr-3"
            size="sm"
            onClick={handleExcelDownload}
          >
            <DownloadIcon className="mr-1" style={{ fontSize: 18 }} />
            ダウンロード
          </Button>
        </div>
        <Row>
          <Col>
            <div className="table-scroll" style={{ height: 'calc(100vh - 272px)' }}>
              <FlexGrid
                ref={flexGrid}
                isReadOnly={true}
                itemsSource={clients}
                selectionMode={'Row'}
                headersVisibility={'Column'}
                style={{ height: '100%' }}
                onDoubleClick={(e) => {
                  const grid = flexGrid.current.control;
                  const ht = grid.hitTest(e);
                  if (ht.cellType === CellType.Cell) {
                    const item = grid.rows[ht.row].dataItem;
                    handleOnClickEditClient(); // カードダイアログを開く処理
                  }
                }}
                copying={(s, e) => {
                  // セル単位でコピーする
                  const selection = s.selection;
                  const selectedCellContent = s.getCellData(selection.row, selection.col, true);
                  // クリップボードにコピーされる内容を上書き
                  e.cancel = true;
                  navigator.clipboard.writeText(selectedCellContent);
                }}
              >
                <FlexGridFilter filterApplied={filterApplied} />
                <FlexGridColumn header="" binding="" isReadOnly={true} width={42}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) => (
                      <span>
                        <Button
                          className="material-symbols-rounded cell-icon btn-fill"
                          variant="primary"
                          title="編集"
                          onClick={handleOnClickEditClient}
                        >
                          edit
                        </Button>
                      </span>
                    )}
                  />
                </FlexGridColumn>
                <FlexGridColumn binding="CYU_MONTH" header="年月" width={80}></FlexGridColumn>
                <FlexGridColumn binding="TITLE" header="カード" width={240}></FlexGridColumn>
                <FlexGridColumn binding="KOUJI_MEI" header="工事名" width={240}></FlexGridColumn>
                <FlexGridColumn
                  binding="ADDRESS"
                  minWidth={240}
                  header="住所"
                  width={'*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="SEIKSAN_KIN"
                  header="売り上げ額"
                  dataType={'Number'}
                  format="n0"
                  width={140}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="CYU_KIN_TOTAL"
                  header="工事原価"
                  dataType={'Number'}
                  format="n0"
                  width={140}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ARARI"
                  header="粗利益額"
                  dataType={'Number'}
                  format="n0"
                  width={140}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ARARI_RITU"
                  header="粗利益率"
                  format="p1"
                  width={100}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="KOUJI_TORI_NAME"
                  header="工事全般"
                  width={160}
                ></FlexGridColumn>

                <FlexGridColumn header="" binding="" isReadOnly={true} width={42}>
                  <FlexGridCellTemplate
                    cellType="Cell"
                    template={(cell) => (
                      <span>
                        <Button
                          className="btn-fill detail_button"
                          variant="secondary"
                          title="カード表示"
                          onClick={handleOnClickEditCard}
                        >
                          <ContactEmergencyOutlinedIcon />
                        </Button>
                      </span>
                    )}
                  />
                </FlexGridColumn>
              </FlexGrid>
            </div>
          </Col>
        </Row>
      </Card>
      {/* メッセージダイアログ */}
      <MessageModal dialog={dialog}></MessageModal>
      {/** 工事台帳モーダル画面 */}
      <KoujiDaichoModal
        params={koujiDaichoModalParam}
        callback={() => {
          searchClients(koujiDaichoModalParam.clientCd);
        }}
      />
      {/** カード編集モーダル画面 */}
      <ClientCardEditModal
        params={cardEditModalParam}
        loadCards={() => {
          searchClients(cardEditModalParam.card.CLIENT_CD);
        }}
      />
      {/** 利益管理モーダル画面 */}
      <KoujiRiekiModal
        params={riekiManageModalParam}
        callback={() => {
          searchClients();
        }}
      />
    </>
  );
};

export default KoujiDaichoList;
